import $ from 'jquery';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import icon from '../assets/images/icons/map-marker.svg';

const GoogleMaps = (el) => {

    const $el = $(el);
    const locations = $el.data('locations');
    const itemsMarkup = $el.data('items');
    const markers = [];
    let currentItemIndex = 0; //needs to be accessible globally
    let map;

    const GOTHENBURG_BOUNDS = {
        north: 57.987577656814686,
        east: 12.898772010922315,
        south: 57.4011788169859,
        west: 11.14233280193794
    };

    async function initMap() {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerView } = await google.maps.importLibrary("marker");
        const position = { lat: 57.705838, lng: 11.972850 };

        map = new Map(document.getElementById("map"), {
            zoom: 11,
            center: position,
            mapId: "DEMO_MAP_ID",
            restriction: {
                latLngBounds: GOTHENBURG_BOUNDS,
                strictBounds: false,
            },
        });

        let infoWindow = new google.maps.InfoWindow({
            content: '',
            ariaLabel: 'Information om fastigheten',
            ariaExpanded: true,
        });

        const uniquePosLocs = locations.filter((l) => {
            const pos = l.latlng;

            if(pos.lat != '' && pos.lng != '') {
                return locations.filter(l2 => l2.latlng.lat != l.latlng.lat && l2.latlng.lng != l.latlng.lng);
            }

        }, []);

        const samePosLocs = locations.reduce((acc, l) => {
            const matches = locations.filter(
                l2 => l2.latlng.lat === l.latlng.lat && l2.latlng.lng === l.latlng.lng);
                if(matches.length > 1) {
                    acc.push(l);
                }
            return acc;
        }, []);

        for(var i = 0, length = uniquePosLocs.length;  i < length;  i++) {
            const marker = generateMarker(uniquePosLocs[i]);
            markers.push(marker);
        }

        if(samePosLocs.length > 1) {
            const groupMarker = generateGroupMarker(samePosLocs);
            markers.push(groupMarker);
        }

        function generateMarker(location) {
            const latlong = location.latlng;

            if(location == null) {
                location = '0';
            }

            let latLng = new google.maps.LatLng(latlong.lat, latlong.lng);
            let marker = new google.maps.Marker({
                position: latLng,
                map: map,
                title: location.title,
                description: location.markup,
                icon: icon,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX),
            });

            marker.addListener('click', (e) => {
                infoWindow.setContent(
                    '<div class="infowindow-single-item">' +
                        location.markup +
                    '</div>'
                );

                infoWindow.open({
                    anchor: marker,
                    map: map,
                    position: latLng,
                });

            });

            return marker;
        }

        function generateGroupMarker(samePosLocs) {
            const latlong = samePosLocs[0].latlng;
            let latLng = new google.maps.LatLng(latlong.lat, latlong.lng);

            let marker = new google.maps.Marker({
                position: latLng,
                map: map,
                title: samePosLocs[0].title,
                description: itemsMarkup[1],
                icon: icon,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX),
                isGroup: true
            });

            if(marker.isGroup) {
                marker.addListener('click', (e) => {
                    infoWindow.setContent(
                        '<div class="infowindow-multiple-items">' +
                            '<ul class="infowindow-multiple-items__list js-infowindow-multiple-list">' +
                                    samePosLocs.map((item) => {
                                        return (
                                            '<li class="infowindow-multiple-items__item js-infowindow-multiple-item">' +
                                                item.markup +
                                            '</li>'
                                        )}).join('') +
                            '</ul>' +
                            '<div class="infowindow-multiple-items__nav">' +
                                '<button class="prev" aria-label="Föregående"> < </button>' +
                                    '<span class="infowindow-multiple-items__pages js-infowindow-pages">' +
                                        1 + ' av ' + samePosLocs.length +
                                    '</span>' +
                                '<button class="next" aria-label="Nästa"> > </button>' +
                            '</div>' +
                        '</div>'
                    );

                    infoWindow.open({
                        anchor: marker,
                        map: map,
                        position: latLng,
                    })
                });
            }
            return marker;
        }

        const showItem = (itemIndex) => {
            if (samePosLocs.length === 0) {
                return;
            }
            if (itemIndex >= samePosLocs.length) {
                itemIndex = 0;
            }
            if (itemIndex < 0) {
                itemIndex = samePosLocs.length - 1;
            }

            $('.js-infowindow-multiple-item').map((_i, x) => {
                x.style.display = 'none';
            });

            $('.js-infowindow-multiple-item')[itemIndex].style.display = 'block';
            currentItemIndex = itemIndex;

            $('.js-infowindow-pages').text(`${currentItemIndex + 1} av ${samePosLocs.length}`)
        }

        infoWindow.addListener('visible', (e) => {
            $('.prev').on('click', (e) => {
                e.preventDefault();
                showItem(currentItemIndex - 1);
            });

            $('.next').on('click', (e) => {
                e.preventDefault();
                showItem(currentItemIndex + 1);
            });

            $('.js-close-infowindow').on('click', (e) => {
                infoWindow.close();
            })

        });
    }

    initMap();

    const searchForm = $('.js-building-search-form');

    searchForm.on('submit', function (e) {
        e.preventDefault();
        const errorMsg = $('.js-building-search-error');
        errorMsg.html(''); //empty container

        let service;
        const inputValue = $('.js-search-input').val();

        const request = {
            query: inputValue + ', Göteborg',
            fields: ["name", "geometry", "formatted_address"],
        };

        service = new google.maps.places.PlacesService(map);

        service.findPlaceFromQuery(request, (results, status) => {

            if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                const address = results[0].formatted_address;
                const name = results[0].name;

                map.setCenter(results[0].geometry.location);

                if(address.includes('Gothenburg, Sweden') || name.includes('Göteborg') || address.includes('Göteborg')) {
                    map.setZoom(14);
                } else {
                    map.setZoom(10);
                    errorMsg.html("Din sökning hade inget resultat inom Higabs område. Försök med ett annat sökord eller använd listvyn istället.");
                }
          } else {
            errorMsg.html("Din sökning hade inget resultat inom Higabs område. Försök med ett annat sökord eller använd listvyn istället.");
        }
         });

    });
};

export default GoogleMaps;
